import ProfileData from './ProfileData';

export default ProfileData;
